import type { ComponentType, HTMLAttributes } from "react";
import {
  CN,
  ES,
  ID,
  JP,
  KR,
  PT,
  RU,
  TH,
  US,
  VN,
} from "country-flag-icons/react/3x2";

import { cn } from "./utils";

type FlagIcon = ComponentType<HTMLAttributes<HTMLElement>>;

const FLAG_ICONS: Record<string, FlagIcon> = {
  CN,
  ES,
  ID,
  JP,
  KR,
  PT,
  RU,
  TH,
  US,
  VN,
};

export type LanguageFlagIconProps = {
  code: string;
  className?: string;
};

export function LanguageFlagIcon({ code, className }: LanguageFlagIconProps) {
  const normalizedCode = code.trim().toUpperCase();
  const Icon = FLAG_ICONS[normalizedCode];

  if (!Icon) {
    return (
      <span
        aria-hidden
        className={cn(
          "flex h-4 w-6 items-center justify-center overflow-hidden rounded-[3px] bg-white ring-1 ring-slate-300/80 shadow-[0_0_0_1px_rgba(15,23,42,0.04)] dark:ring-slate-600/80",
          className
        )}
      />
    );
  }

  return (
    <span
      aria-hidden
      className={cn(
        "flex h-4 w-6 items-center justify-center overflow-hidden rounded-[3px] bg-white ring-1 ring-slate-300/80 shadow-[0_0_0_1px_rgba(15,23,42,0.04)] dark:ring-slate-600/80",
        className
      )}
    >
      <Icon aria-hidden className="h-full w-full object-cover" />
    </span>
  );
}
